import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const ProfileManager = ({ businessData, onUpdate }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    name: businessData?.name,
    description: businessData?.description,
    phone: businessData?.phone,
    email: businessData?.email,
    address: businessData?.address,
    facebook: businessData?.socialMedia?.facebook || '',
    instagram: businessData?.socialMedia?.instagram || '',
    whatsapp: businessData?.socialMedia?.whatsapp || ''
  });

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e?.target?.name]: e?.target?.value
    }));
  };

  const handleSave = () => {
    onUpdate(formData);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setFormData({
      name: businessData?.name,
      description: businessData?.description,
      phone: businessData?.phone,
      email: businessData?.email,
      address: businessData?.address,
      facebook: businessData?.socialMedia?.facebook || '',
      instagram: businessData?.socialMedia?.instagram || '',
      whatsapp: businessData?.socialMedia?.whatsapp || ''
    });
    setIsEditing(false);
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-card p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground">Perfil del Negocio</h3>
          <p className="text-sm text-muted-foreground mt-1">
            Administra la información de tu empresa
          </p>
        </div>
        {!isEditing ? (
          <Button
            variant="outline"
            iconName="Edit"
            onClick={() => setIsEditing(true)}
          >
            Editar
          </Button>
        ) : (
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              iconName="X"
              onClick={handleCancel}
            >
              Cancelar
            </Button>
            <Button
              variant="default"
              iconName="Check"
              onClick={handleSave}
            >
              Guardar
            </Button>
          </div>
        )}
      </div>
      <div className="space-y-6">
        <div className="flex items-center gap-4">
          <div className="w-20 h-20 rounded-lg overflow-hidden border-2 border-border">
            <Image
              src={businessData?.logo}
              alt={`Logo de ${businessData?.name} mostrando la identidad visual de la empresa`}
              className="w-full h-full object-cover"
            />
          </div>
          {isEditing && (
            <Button variant="outline" iconName="Upload" size="sm">
              Cambiar Logo
            </Button>
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Nombre del Negocio"
            name="name"
            value={formData?.name}
            onChange={handleChange}
            disabled={!isEditing}
            required
          />
          <Input
            label="Teléfono"
            name="phone"
            type="tel"
            value={formData?.phone}
            onChange={handleChange}
            disabled={!isEditing}
            required
          />
          <Input
            label="Email"
            name="email"
            type="email"
            value={formData?.email}
            onChange={handleChange}
            disabled={!isEditing}
            required
          />
          <Input
            label="Dirección"
            name="address"
            value={formData?.address}
            onChange={handleChange}
            disabled={!isEditing}
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Descripción
          </label>
          <textarea
            name="description"
            value={formData?.description}
            onChange={handleChange}
            disabled={!isEditing}
            className="w-full min-h-[100px] px-4 py-3 rounded-lg border border-input bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring resize-none disabled:opacity-50 disabled:cursor-not-allowed"
            maxLength={300}
          />
          <p className="text-xs text-muted-foreground mt-1 text-right">
            {formData?.description?.length}/300 caracteres
          </p>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-foreground mb-3 flex items-center gap-2">
            <Icon name="Share2" size={16} />
            Redes Sociales
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <Input
              label="Facebook"
              name="facebook"
              placeholder="https://facebook.com/tu-negocio"
              value={formData?.facebook}
              onChange={handleChange}
              disabled={!isEditing}
            />
            <Input
              label="Instagram"
              name="instagram"
              placeholder="https://instagram.com/tu-negocio"
              value={formData?.instagram}
              onChange={handleChange}
              disabled={!isEditing}
            />
            <Input
              label="WhatsApp"
              name="whatsapp"
              placeholder="3001234567"
              value={formData?.whatsapp}
              onChange={handleChange}
              disabled={!isEditing}
            />
          </div>
        </div>

        <div className="bg-muted rounded-lg p-4">
          <div className="flex items-start gap-3">
            <Icon name="Image" size={20} color="var(--color-primary)" />
            <div className="flex-1">
              <p className="text-sm font-medium text-foreground mb-2">Galería de Productos</p>
              <div className="grid grid-cols-3 sm:grid-cols-5 gap-2">
                {businessData?.productImages?.map((image, index) => (
                  <div key={index} className="aspect-square rounded-lg overflow-hidden border border-border">
                    <Image
                      src={image?.url}
                      alt={image?.alt}
                      className="w-full h-full object-cover"
                    />
                  </div>
                ))}
              </div>
              {isEditing && (
                <Button variant="outline" iconName="Plus" size="sm" className="mt-3">
                  Agregar Imágenes
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileManager;